import { defineComponent as _defineComponent } from 'vue'
import { User, StatementType, TtStrikeNumberReport } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { startCase, sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import { useQuery } from "@vue/apollo-composable";
import { computed } from "vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TtStrikeStatementsModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    endReleaseDate: null,
    userId: null,
    statementType: { default: StatementType.TicketIn }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, startReleaseDate?: string, endReleaseDate?: string, userId: User["userId"], statementType: StatementType };





const { $t } = useTranslation();

const { result: ttStrikeNumberReportsResult, loading } = useQuery<{
  ttStrikeNumberReports: TtStrikeNumberReport[];
}>(queries.ttStrikeNumberReports, {
  releaseDateStart: props.startReleaseDate,
  releaseDateEnd: props.endReleaseDate,
  userId: props.userId,
  statementType: props.statementType,
});

const ttStrikeNumberReports = computed(() => {
  return ttStrikeNumberReportsResult.value?.ttStrikeNumberReports;
});

const processedStrikeNumberReports = computed(() => {
  return ttStrikeNumberReports.value
    ?.map((report) => {
      return {
        ...report,
        summary: {
          strikeAmount: sumBy(report.rows, (row) => row.strikeAmount),
        },
      };
    })
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

function formatDate(date: string) {
  return customMoment(date).format("DD MMM YYYY");
}
function formatDatetime(date: string) {
  return customMoment(date).format("DD/MMM HH:mm:ss");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, emit, $t, ttStrikeNumberReportsResult, loading, ttStrikeNumberReports, processedStrikeNumberReports, formatDate, formatDatetime, toggleModal, formatDollar, startCase }
}

})